import { stringify } from "qs";
import newRequest, { buildBaseURL } from "../../../utils/http/newRuequest";

export const QRCODE_STATUS = {
  STATUS_CREATED: 0,
  STATUS_GENERATING_QRCODE: 1,
  STATUS_GENERATED_QRCODE: 2,
  STATUS_GENERATING_EXCEL: 3,
  STATUS_GENERATED_EXCEL: 4,
};

export const generateQrcode = async ({ id, token }) => {
  const url =
    buildBaseURL("v1", "lottery") +
    `merchant/lottery-qrcode/${id}/generate-qrcode`;
  const result = await newRequest.post(url, [], token);

  return {
    data: result.data ?? [],
    total: result.total ? result.total : 10,
  };
};
export const generateExcel = async ({ id, token }) => {
  const url =
    buildBaseURL("v1", "lottery") +
    `merchant/lottery-qrcode/${id}/generate-excel`;
  const result = await newRequest.post(url, [], token);

  return {
    data: result.data ?? [],
    total: result.total ? result.total : 10,
  };
};

/**
 * List VIP users for this merchant (for transfer box to VIP).
 * Backend: GET /api/v6/merchant/vip?filter[parent]=true&filter[mobile]=...&merchant_id=...
 */
export const getVipList = async ({
  token,
  merchant_id,
  keyword,
  page = 1,
  limit = 50,
} = {}) => {
  const query = {
    merchant_id,
    page,
    limit,
  };
  if (keyword) query["filter[mobile]"] = keyword;
  const url =
    buildBaseURL("v6", "") + `merchant/vip?${stringify(query)}`;
  const result = await newRequest.get(url, token);
  return {
    data: result.data?.data ?? result.data ?? [],
    total: result.data?.total ?? result.total ?? 0,
  };
};

/**
 * Transfer TYPE_BOX lottery qrcode item to VIP. Box + all its product items are assigned to the VIP.
 * Backend: POST /api/v1/merchant/lottery-qrcode/transfer-to-vip
 */
export const transferToVip = async ({ item_id, vip_user_id, token }) => {
  const url =
    buildBaseURL("v1", "lottery") +
    `merchant/lottery-qrcode/transfer-to-vip`;
  const result = await newRequest.post(
    url,
    { item_id, vip_user_id },
    token
  );
  return result.data;
};

/**
 * Get a specific user's lottery qrcode items grouped by qrcode, then by box.
 * Backend: GET /api/v1/merchant/lottery-qrcode/user/{user_id}/items-by-box
 */
export const getUserItemsByBox = async ({ user_id, token }) => {
  const url =
    buildBaseURL("v1", "lottery") +
    `merchant/lottery-qrcode/user/${user_id}/items-by-box`;
  const result = await newRequest.get(url, token);
  return result.data;
};
